<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "FulfilmentPage"
}
</script>

<style scoped>

</style>